export function calcularDias(d1: string): number {
  const data1 = new Date(d1);
  const data2 = new Date();
  const diferenca = Math.abs(data1.getTime() - data2.getTime());
  return diferenca / (1000 * 60 * 60 * 24);
}
